(function () {
  async function updateCartBubble() {
    const headerCart = document.getElementById('cart-icon-bubble');
    if (!headerCart) return false;

    try {
      const response = await fetch(`${window.location.pathname}?section_id=cart-icon-bubble`);
      const html = await response.text();
      const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
      const el = parsedHTML.querySelector('.cart-count-bubble');

      if (document.querySelector('.cart-count-bubble')) {
        document.querySelector('.cart-count-bubble').innerHTML = el.innerHTML;
      } else {
        headerCart.append(el);
      }
    } catch (error) {
      console.error('Error updating cart bubble:', error);
    }
  }

  updateCartBubble();

  // Listen for the rebuy change because this also updates the cart bubble but removes the accessibility
  document.addEventListener('rebuy:cart.change', () => {
    updateCartBubble();
  });
})();
